import { Component } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import * as fromAuth from '../../../auth/reducers';
import * as fromRoot from '../../../reducers';
import * as fromSettings from '../../../settings/reducers';

/**
 * "Try the new portal" in the sidebar footer (SA-8857).
 *
 * The link carries the clinic so the new portal opens on it instead of showing a picker. Renders
 * nothing unless the clinic has opted in, the environment names a new portal, and a clinic is
 * selected.
 *
 * SA-9282: the new portal's `?clinic=` param carries the business unit id (`salve.clinic.token`),
 * behind a uuid guard that treats anything else as absent. That value is already in the store --
 * `getClinicId` holds the token, not an id (`auth.reducer.ts:66`), and it is what every request
 * sends as `x-salve-clinic-token` -- so the link is built straight from it.
 */
@Component({
  selector: 'portal-new-portal-link',
  templateUrl: './new-portal-link.container.html',
  styleUrls: ['./new-portal-link.container.scss']
})
export class NewPortalLinkContainer {
  public href$: Observable<string | null>;
  public text$: Observable<any>;

  constructor(private _store: Store<fromRoot.State>) {
    this.text$ = this._store.pipe(
      select(fromSettings.getSectionTranslations('NewPortal'))
    );

    this.href$ = combineLatest(
      this._store.pipe(select(fromAuth.getClinicOptions)),
      this._store.pipe(select(fromAuth.getClinicId))
    ).pipe(
      map(([options, clinicToken]) => {
        const optedIn = !!(
          options &&
          options.newPortalOptions &&
          options.newPortalOptions.enabled
        );

        if (!optedIn || !environment.newPortalUrl || !clinicToken) {
          return null;
        }

        return `${environment.newPortalUrl}/?clinic=${encodeURIComponent(
          clinicToken
        )}`;
      })
    );
  }
}
